export default "__VITE_ASSET__DLZDQKzX__"